const customPointTagGroup = {
    text: "Промежуточные точки",
    tooltip: `При использовании тегов ниже заменяйте значение X на букву нужной вам точки, например "Точка В"`,
    items: [
        { id: "Точка X: Телефон контактного лица", text: "Точка X: Телефон контактного лица" },
        { id: "Точка X: Контактное лицо", text: "Точка X: Контактное лицо" },
        { id: "Точка X: Комментарий", text: "Точка X: Комментарий" },
        { id: "Точка X: Типы погрузки", text: "Точка X: Типы погрузки" },
        { id: "Точка X: Время", text: "Точка X: Время" },
        { id: "Точка X: Дата", text: "Точка X: Дата" },
        { id: "Точка X: Дата и время", text: "Точка X: Дата и время" },
        { id: "Точка X: Адрес", text: "Точка X: Адрес" },
        { id: "Точка X: Название населенного пункта", text: "Точка X: Название населенного пункта" },
        { id: "Точка X: Грузоотправитель/Грузополучатель", text: "Точка X: Грузоотправитель/Грузополучатель" },
        { id: "Точка X: Тип", text: "Точка X: Тип" },
    ],
};

const imageDocumentTagGroup = {
    text: "Изображения",
    items: [
        { id: "Подпись", text: "Подпись" },
        { id: "Печать", text: "Печать" },
        { id: "Подпись бухгалтера", text: "Подпись бухгалтера" },
        { id: "Печать бухгалтера", text: "Печать бухгалтера" },
        { id: "Логотип", text: "Логотип" },
    ],
};

const customDocumentTagGroups = [imageDocumentTagGroup, customPointTagGroup];

const appendCustomDocumentTagGroups = (
    documentTags: Array<{ text: string; tooltip?: string; items: Array<{ id: string; text: string }> }>,
) => {
    const nextDocumentTags = documentTags.map((group) => ({ ...group, items: [...group.items] }));

    customDocumentTagGroups.forEach((group) => {
        const existingGroup = nextDocumentTags.find((item) => item.text === group.text);

        if (!existingGroup) {
            nextDocumentTags.push(group);
            return;
        }

        const existingTagIds = new Set(existingGroup.items.map((item) => item.id));
        existingGroup.items.push(...group.items.filter((item) => !existingTagIds.has(item.id)));
    });

    return nextDocumentTags;
};

export { appendCustomDocumentTagGroups, customPointTagGroup };
